import * as React from "react";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import "rc-slider/assets/index.css";
import { VapeWrap } from "./VapeView";
import Tick from '../resources/tick.svg';
import TickFilled from '../resources/tick_filled.svg';
import CrossFilled from '../resources/cross_filled.svg';
import Cross from '../resources/cross.svg';
import NormalGirl from '../resources/normal-girl.svg';
import Alcohol from '../resources/alcohol-mi2.svg';
import Dizzy from '../resources/dizzy.svg';
import Clock from '../resources/clock.gif';

const Alcohol2View = (props) => {
    const [isVisible, setIsVisible] = useState(false);
    const divRef = useRef(null);
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting);
        },
        {
          threshold: 0.1, // Adjust this value as needed
        }
      );
  
      if (divRef.current) {
        observer.observe(divRef.current);
      }
  
      return () => {
        if (divRef.current) {
          observer.unobserve(divRef.current);
        }
      };
    }, []);

    const questions = [
        {
            question: "While drinking, I have said or done embarrassing things."
        },
        {
            question: "I have had a hangover (headache, sick stomach) the morning after I had been drinking."
        },
        {
            question: "I have felt very sick to my stomach or thrown up after drinking."
        },
        {
            question: "I often have ended up drinking on nights when I had planned not to drink."
        },
        {
            question: "I have taken foolish risks when I have been drinking."
        },
        {
            question: "I have passed out from drinking."
        },
        {
            question: "I have found that I needed larger amounts of alcohol to feel any effect, or that I could no longer get high or drunk on the amount that used to get me high or drunk."
        },
        {
            question: "When drinking, I have done impulsive things that I regretted later."
        },
        {
            question: "I've not been able to remember large stretches of time while drinking heavily."
        },
        {
            question: "I have driven a car when I knew I had too much to drink to drive safely."
        },
        {
            question: "I have not gone to work or missed classes at school because of drinking, a hangover, or illness caused by drinking."
        },
        {
            question: "My drinking has gotten me into sexual situations I later regretted."
        },
        {
            question: "I have often found it difficult to limit how much I drink."
        },
        {
            question: "I have become very rude, obnoxious or insulting after drinking."
        },
        {
            question: "I have woken up in an unexpected place after heavy drinking."
        },
        {
            question: "I have felt badly about myself because of my drinking."
        },
        {
            question: "I have had less energy or felt tired because of my drinking."
        },
        {
            question: "The quality of my work or schoolwork has suffered because of my drinking."
        },
        {
            question: "I have spent too much time drinking"
        },
        {
            question: "I have neglected my obligations to family, work, or school because of drinking."

        },
        {
            question: "My drinking has created problems between myself and my boyfriend/girlfriend/spouse, parents, or other near relatives."
        },
        {
            question: "I have been overweight because of drinking."
        },
        {
            question: "My physical appearance has been harmed by my drinking."
        },
        {
            question: "I have felt like I needed a drink after I'd gotten up (that is, before breakfast)."
        }
            
     ];
    // const initialAnswersState = {};
    const [answers, setAnswers] = React.useState([999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999, 999]);
    React.useEffect(() => {
        const filteredAnswers = answers.filter(value => value === 999);
        if (filteredAnswers.length == 0) {
            let data = {
                yaacq_1 : answers[0],
                yaacq_2 : answers[1],
                yaacq_3 : answers[2],
                yaacq_4 : answers[3],
                yaacq_5 : answers[4],
                yaacq_6 : answers[5],
                yaacq_7 : answers[6],
                yaacq_8 : answers[7],
                yaacq_9 : answers[8],
                yaacq_10 : answers[9],
                yaacq_11 : answers[10],
                yaacq_12 : answers[11],
                yaacq_13 : answers[12],
                yaacq_14 : answers[13],
                yaacq_15 : answers[14],
                yaacq_16 : answers[15],
                yaacq_17 : answers[16],
                yaacq_18 : answers[17],
                yaacq_19 : answers[18],
                yaacq_20 : answers[19],
                yaacq_21 : answers[20],
                yaacq_22 : answers[21],
                yaacq_23 : answers[22],
                yaacq_24 : answers[23]
            }
            props.setAlcoholInfoData(data);
            props.setNextButton(true);
            props.onAllAnswered(false);
        } else {
            props.setNextButton(false);
        }
    }, [answers]);

    const handleAnswerChange = (index, value) => {
        // console.log("index", index, "value", value);
        const newAnswers = [...answers];
        newAnswers[index] = value;
        setAnswers(newAnswers);
    }

    return(
        <VapeWrap>      
                <h2>Alcohol</h2>
                <h3>In the last month,</h3>
                {questions.map((i, index) => {
                    return(
                        <>
                        <QuestionSection style={{color: (props.showUnanswered && (answers[index] == 999)) ? 'red' : 'black'}}>
                        <div>
                        <QuestionNumber>
                            <span>{index+1}</span>
                        </QuestionNumber>
                        <DataWrap>
                        <p style={{width: '90%'}}>{i.question}</p>
                        <div>
                       <img className="tick" src={answers[index] == 1 ? TickFilled : Tick} width={40} height={40} onClick={() => handleAnswerChange(index, 1)} />
                       <img className="cross" src={answers[index] == 0 ? CrossFilled : Cross} width={35} height={35} onClick={() => handleAnswerChange(index, 0)} />
                        </div>
                        </DataWrap>
                        </div>
                    </QuestionSection>
                                    
                                   {
                                        index === 18 &&(
                                            <div className="clock-gif-div" style={{marginLeft: '-10%'}}>
                                                <img className="clock-gif" src={Clock} width={"12%"} />
                                                {/* <img src={Drinking} width={"10%"} /> */}
                                            </div>
                                        )
                                    }
                                    </>
                    )
                })}
        </VapeWrap>
    );
}

const QuestionNumber = styled.div`
    background-color: #4D71E5;
    width: 20px;
    height: 20px;
    position: absolute;
        left: -40px;
        top: 10px;
    border-radius: 50%;
    font-size: 13px;
    color: white;
    display: flex;
    justify-content: center;
    span{
        align-self: center;
        ${'' /* margin-bottom: 3px; */}
    }

    @media only screen and (max-width: 780px) {
        font-size: 11px;
    }

    @media only screen and (max-width: 576px) {
        font-size: 9px;
    }


`;

const DataWrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    div{
        display: flex;
        align-items: center;
        width: 100px;
        justify-content: space-between;
    }
    img{
        cursor: pointer;
    }
    @media only screen and (max-width: 768px) {
        padding-top: 5px;

        .tick{
            width: 30px;
            height: 30px;
        }
        .cross{
            width: 27px;
            height: 27px;
        }
    }
    @media only screen and (max-width: 576px) {
        .tick{
            width: 30px;
            height: 30px;
        }
        .cross{
            width: 27px;
            height: 27px;
        }
    }
`;

const AlcoholImgDiv = styled.section`
    position: relative;
    height: 80px;
        /* text-align: right; */
        /* width: 10%; */
        /* height: 10%; */
        @keyframes normal-girl-animation {
    0%   { right:20%;}
    /* 25%  { left:200px; top:0px;}
    50%  {left:200px; top:200px;}
    75%  { left:0px; top:200px;} */
    100% {right: 10%; display: none;}
    }
    @keyframes alcohol-animation {
    0%   { right:0%;}
    /* 25%  { left:200px; top:0px;}
    50%  {left:200px; top:200px;}
    75%  { left:0px; top:200px;} */
    100% {right: 10%; display: none;}
    }
    @keyframes dizzy-animation {
    0%   { display: none; opacity: 0;}
    /* 1%   { display: contents; opacity: 0;} */
    /* 25%  { left:200px; top:0px;}
    50%  {left:200px; top:200px;}
    75%  { left:0px; top:200px;} */
    75%   { display: unset; opacity: 0;}
    100% {opacity: 1;}
    }
    img{
        width: 7%;
    }
    .girl{
        position: absolute;
        right: 20%;
    }
    .alcohol-img{
        position: absolute;
        right: 0%;
    }
    .dizzy{
        position: absolute;
        right: 10%;
    }
    .animate-normal-girl{
        animation-name: normal-girl-animation;
        animation-duration: 4s;
        animation-fill-mode: forwards;
        /* animation-iteration-count: 1; */
    }
    .animate-alcohol{
        animation-name: alcohol-animation;
        animation-duration: 4s;
        animation-fill-mode: forwards;
        /* animation-iteration-count: 1; */
    }
    .animate-dizzy{
        animation-name: dizzy-animation;
        animation-duration: 4s;
        /* animation: fadeIn ease 4s; */
        /* animation-fill-mode: forwards; */
        /* animation-iteration-count: 1; */
    }

    .clock-gif-div{
        margin-left: -10%;
    }
    @media only screen and (max-width: 1300px) {
        img{
            width: 9%;
        }
    }
    @media only screen and (max-width: 950px) {
        img{
            width: 12%;
        }
    }
    @media only screen and (max-width: 768px) {
        height: 70px;
        img{
            width: 12%;
        }
    }

    @media only screen and (max-width: 576px) {
        height: 35px;
        img{
            width: 12%;
        }
        .clock-gif-div{
            margin-left: -15%;
        }
    }
    

    
`;

const QuestionSection = styled.section`
    position: relative;
    margin: 20px 0;
    padding: 0;
    p{
        font-size: 18px;
    }
    h3{
        line-height: 1.5;
    }
    @media only screen and (max-width: 768px) {
       p{
        font-size: 16px;
       }
    }
    @media only screen and (max-width: 576px) {
       p{
        font-size: 14px;
       }
    }
`;

export default Alcohol2View;